import { useApiQuery } from "../../../hooks/customHooks"

export const getUsersOrders = (userId) => {

    const order = useApiQuery('user/orders?user_id=' + userId ?? null);

    return order;
}